import { graphql } from '@teachino/shared-infrastructure';

export const reorderTopicInFolderMutation = graphql(`
  mutation ReorderTopicInFolder(
    $topicId: String!
    $position: Int!
    $folderId: String
  ) {
    moveTopic(
      moveTopicInput: {
        id: $topicId
        position: $position
        libraryFolderId: $folderId
      }
    ) {
      __typename
    }
  }
`);
